var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SelectionModel = function () {
    var self = this;

    lib_core.Model.apply(this);

    this.selection = this.set("selection", false);
    this.inspectorSubjects = this.set("inspectorSubjects", false); // TODO: do we keep this?
    this.selectedSubElement = this.value("selectedSubElement", false);

    this.clickedElement = this.value("clickedElement", false); // element within the selection that controls the move/snap etc.

    this.selection_box_start = this.value("selection_box_start", true);
    this.selection_box_end   = this.value("selection_box_end", true);

    // observers
    this.selection_box_end.onChange('model', function(){
        if (self.selection_box_end() !== null) {
            self.selectElementsInBox();
        }
    },10);

    this.selectedBoundingBox = this.shadow("selectedBoundingBox",
        function () {
            var boundingBox = null;
            self.selection.forEach(function(element) {
                if(element.data && element.data.boundingBox) {
                    var bb = element.data.boundingBox && element.data.boundingBox();
                    if (bb) boundingBox = bb.merge(boundingBox);
                }
            });
            return boundingBox;
        },
        null,
        [this.selection]
    );
    this.selection.onAdd("selectionOnAdd", function (element) {
        self.addToInspectorSubjects(element);
        if (element.setSelected) element.setSelected(true);
        if(element.setFocus) element.setFocus(true);
        if(element.boundingBox) self.selectedBoundingBox.addTrigger(element.boundingBox);
    });
    this.selection.onRemove("selectionOnRemove", function (s, element) {
        self.removeFromInspectorSubjects(element);
        if (element.setSelected) element.setSelected(false);
        if(element.setFocus) element.setFocus(false);
        if(element.boundingBox) self.selectedBoundingBox.removeTrigger(element.boundingBox);
    });

    this.onInit("init", function(){
        this.selectables = this.parent().interactionModels;
    });

    this.selectedSubElement.onChange("setSelectedSubElement", function(value, old) {
        if (old && old.setSelectedSubElement)
            old.setSelectedSubElement(false);
        if(value && value.setSelectedSubElement)
            value.setSelectedSubElement(true);
    });
};

lib_core.inherit(SelectionModel, lib_core.Model);
lib_core.JsonParser.registerClass(SelectionModel, "SelectionModel");

module.exports = SelectionModel;

SelectionModel.prototype.addToInspectorSubjects = function (element) {
    this.inspectorSubjects.add(element);
};

SelectionModel.prototype.removeFromInspectorSubjects = function (element) {
    if(this.inspectorSubjects.contains(element)) {
        this.inspectorSubjects.remove(element);
    }
};

SelectionModel.prototype.emptySelection = function() {
    if(this.selection.size()) this.selection.removeAll();
    if(this.clickedElement()) this.clickedElement(null);
    if(this.inspectorSubjects.size()) this.inspectorSubjects.removeAll();
    if(this.selectedSubElement()) this.selectedSubElement(null);
};

SelectionModel.prototype.invertSelection = function()
{
    var self = this;

    var selectables = self.selectables();
    self.selection.forEach(function(selected){
        selectables.remove(selected);
    });

    this.emptySelection();
    this.addAllToSelection(selectables);
};

/**
 * As items are in the selection box, we want to add them
 *   Items that were in the box previously, but are no longer, should be removed
 * Sets:
 *   A = all selectable items
 *   B = all currently selected items
 *   C = items from A that should be selected (in BB)
 *   items to remove = B - (C intersect B)
 *   items to add = C - (C intersect B)
 * @author Ed Pataky
 */
SelectionModel.prototype.selectElementsInBox = function() {
    var self = this;

    if (this.selection_box_end() !== null) {
        var bb = new lib_geometry.PointSet([this.selection_box_start(), this.selection_box_end()]).getBB();
        var elements_in_box = this.getSelectablesInBox(bb);
        var toRemove = this.selection.filter(function(element){
            return !elements_in_box.contains(element);
        });
        var toAdd = elements_in_box; // optimization, just add all, check will be done in hashmap, .setSubtract(CintersectB);
        self.selection.addAll(toAdd);
        self.selection.removeAll(toRemove);
        bb = elements_in_box = toRemove = toAdd = null; // cleanup
    }
};

SelectionModel.prototype.addToSelection = function(element) {
    console.assert(element);
    // console.assert(element instanceof lib_core.AbstractInteractionModel);
    this.selection.add(element);
};

SelectionModel.prototype.addAllToSelection = function(elements) {
    this.selection.addAll(elements);
};

SelectionModel.prototype.removeFromSelection = function(element) {
    this.selection.remove(element);
};

SelectionModel.prototype.removeAllFromSelection = function(element) {
    this.selection.removeAll(element);
};

/**
 * Delete a selection. Calls the remove method of the selected object, if defined.
 * @param mode The deletion mode or null/undefined (useful to handle special cases)
 */
SelectionModel.prototype.deleteSelection = function(mode) {
    var selection_copy = this.selection.copy();
    this.emptySelection();

    selection_copy.forEach(function(selectable){
        if (selectable.remove !== undefined) {
            selectable.remove(mode);
        }
    });
};

SelectionModel.prototype.selectionRemovable = function() {
    return true; // everything should be removeable, override in specific editor model otherwise
};

SelectionModel.prototype.onElementSelected = function() {
};

SelectionModel.prototype.onElementClicked = function() {
};

SelectionModel.prototype.getSelectablesInBox = function(bb) {
    var elements = this.selectables();
    var self = this;

    return elements.filter(function(element){
        /**
         * InteractionModels that implement inBB have special select functionality to allow
         * select if any part of shape selected when select box from right to left,
         * or select the shape when all of the shape is selected from left to right
         * If the IM does not implement this function just check if the position of the shape is in the BB
         */
        if(element.inBB) {
            var selectAnyMode = (self.selection_box_end().getX() < self.selection_box_start().getX());
            return element.inBB(bb, selectAnyMode);
        } else if(element.pos) {
            // elements that do not implement this interface are selected
            // simply based on whether their pos is in the BB
            return element.pos().containedByBB(bb);
        }
        return false;
    });
};

SelectionModel.prototype.getInspectorSubjects = function() {
    return this.inspectorSubjects;
};

SelectionModel.prototype.getInspectorSubelementSubject = function() {
    return this.getSelectedSubelement();
};

SelectionModel.prototype.getSelectedSubelement = function() {
    return this.selectedSubElement();
};

